import difference from "lodash/difference";
import { ApplicationHistoryFieldDisplayName } from "models/Application.model";
import { parseParticipantUpdateItemParticipantTypes } from "models/Participant.model";
import { QualificationUtil } from "models/Qualification.model";

export const parseChangeListItem = (before: string, after: string, displayName: string) => {
  // Special delta logic for participant types
  if (displayName === ApplicationHistoryFieldDisplayName.participantTypes) {
    const oldParticipantTypes = parseParticipantUpdateItemParticipantTypes(before);
    const newParticipantTypes = parseParticipantUpdateItemParticipantTypes(after);

    // Get the item difference between the old and new participant types
    const removed = difference(oldParticipantTypes, newParticipantTypes).join(", ");
    const added = difference(newParticipantTypes, oldParticipantTypes).join(", ");

    return [removed, added];
  } else if (displayName === ApplicationHistoryFieldDisplayName.qualifications) {
    // Convert ";" separator into "," for now
    const oldQualifications = QualificationUtil.parseQualificationUpdateItem(before);
    const newQualifications = QualificationUtil.parseQualificationUpdateItem(after);

    return [oldQualifications.join(", "), newQualifications.join(", ")];
  }

  return [before, after];
};
